// Built images read config from /env.json (written at container start from VITE_* env vars),
// so one image can be promoted across phases and countries. `vite dev` and tests use
// import.meta.env instead. Never put secrets in these keys: /env.json is public.
export const RUNTIME_CONFIG_URL = "/env.json";

export const REQUIRED_RUNTIME_CONFIG_KEYS = ["VITE_API_URL", "VITE_ADMIN_APP_URL"];

// Not every country sets these today (e.g. SBA is SG-only); clients treat them as unset.
export const OPTIONAL_RUNTIME_CONFIG_KEYS = [
  "VITE_REVENUE_API_URL",
  "VITE_SERVICE_DELIVERY_API_URL",
  "VITE_SLEEK_BACK_API_URL",
  "VITE_SBA_API_URL",
  "VITE_APP_ORIGIN",
];

let loaded = null;

export function parseRuntimeConfig(input) {
  if (!input || typeof input !== "object" || Array.isArray(input)) {
    throw new Error("Runtime config must be a JSON object");
  }

  const missing = REQUIRED_RUNTIME_CONFIG_KEYS.filter((key) => !input[key]);
  if (missing.length > 0) {
    throw new Error(`Runtime config is missing ${missing.join(", ")}`);
  }

  const config = {};
  for (const key of [...REQUIRED_RUNTIME_CONFIG_KEYS, ...OPTIONAL_RUNTIME_CONFIG_KEYS]) {
    if (input[key]) {
      config[key] = input[key];
    }
  }
  return Object.freeze(config);
}

export async function loadRuntimeConfig({ fetchImpl = fetch, env = import.meta.env } = {}) {
  if (loaded) {
    return loaded;
  }

  if (env.DEV || env.MODE === "test") {
    loaded = parseRuntimeConfig(env);
    return loaded;
  }

  const response = await fetchImpl(RUNTIME_CONFIG_URL, { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`Failed to load ${RUNTIME_CONFIG_URL}: HTTP ${response.status}`);
  }
  loaded = parseRuntimeConfig(await response.json());
  return loaded;
}

export function getRuntimeConfig() {
  if (!loaded) {
    throw new Error("Runtime config not loaded; call loadRuntimeConfig() before rendering the app");
  }
  return loaded;
}

export function resetRuntimeConfig() {
  loaded = null;
}
